import { init as ampInit, track as ampTrack, identify as ampIdentify, Identify, setUserId as ampSetUserId } from '@amplitude/analytics-browser';
import { guestbookSites, environment } from '../../settings/IntegrationConstants';

let inited = false;

export const initAmplitude = (): void => {
  if (inited) return;
  const key = guestbookSites[environment]?.amplitude?.api_key;
  if (!key) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[Amplitude] Missing API key for environment:', environment);
    }
    return;
  }
  ampInit(key, {
    autocapture: { elementInteractions: true },
  });
  inited = true;
};

export const setUser = (userId: string): void => {
  initAmplitude();
  if (!userId) return;
  ampSetUserId(userId);
};

export const setUserProperties = (props: Record<string, any> = {}): void => {
  initAmplitude();
  try {
    const identify = new Identify();
    Object.entries(props || {}).forEach(([k, v]) => identify.set(k, v as any));
    ampIdentify(identify);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[Amplitude] Identify API not available in this version');
    }
  }
};

export const track = (eventName: string, props?: Record<string, any>): void => {
  initAmplitude();
  ampTrack(eventName, props);
};

export default {
  initAmplitude,
  setUser,
  setUserProperties,
  track,
};

